import Vue from 'vue'
import { mapGetters } from 'vuex'

const openerSync = new Vue({})

export default {
  template: '<div></div>',

  provide: { openerSync },

  data() {
    return {
      query: ''
    }
  },

  computed: {
    ...mapGetters('user', ['isAuthenticated']),

    stage() {
      let calendar = this.$parent.$refs.calendar

      if (typeof calendar !== 'undefiend') {
        return !!calendar.stage.order
      }

      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/shared/components/alphabet/alphabet.js